import React from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setFiltrosDirecto } from '../../store/actions/dashboard-directo-action'
import * as estilos from '../../common/dashboard-estilos'

const CRITERIOS_FECHA = [
    '',
    'Fecha Ingreso',
    'Fecha Siniestro',
    'Fecha Asignacion'
]

const FILTROS_VACIOS = {
    responsableId: '',
    mes: '',
    fechadesde: '',
    fechahasta: '',
    criteriosFecha: ''
}

const FiltroPanelDirecto = ({ onBuscar }) => {
    const dispatch = useDispatch()
    const filtros = useSelector((state) => state.dashboardDirectoReducer.filtros)
    const mesesDisponibles = useSelector((state) => state.dashboardDirectoReducer.mesesDisponibles)
    const proveedores = useSelector((state) => state.dashboardDirectoReducer.proveedores)

    const handleChange = (campo, valor) =>
        dispatch(setFiltrosDirecto({ [campo]: valor }))

    // El mes y el rango de fechas son excluyentes: al elegir uno se limpia el otro.
    const handleMesChange = (valor) =>
        dispatch(setFiltrosDirecto({ mes: valor, criteriosFecha: '', fechadesde: '', fechahasta: '' }))

    const handleRangoChange = (campo, valor) =>
        dispatch(setFiltrosDirecto({ [campo]: valor, mes: '' }))

    return (
        <div style={estilos.filtroPanel}>
            <Row className='g-2 align-items-end'>

                <Col xs={12} md={4}>
                    <Form.Label className='fw-semibold small mb-1'>Responsable / Estudio</Form.Label>
                    <Form.Select
                        size='sm'
                        value={filtros.responsableId}
                        onChange={(e) => handleChange('responsableId', e.target.value)}
                    >
                        <option value=''>— Todos —</option>
                        {proveedores.map((p) => (
                            <option key={p.id} value={p.id}>{p.nombre}</option>
                        ))}
                    </Form.Select>
                </Col>

                <Col xs={12} md={2}>
                    <Form.Label className='fw-semibold small mb-1'>Mes</Form.Label>
                    <Form.Select
                        size='sm'
                        value={filtros.mes}
                        onChange={(e) => handleMesChange(e.target.value)}
                    >
                        <option value=''>— Sin filtro —</option>
                        {mesesDisponibles.map((m) => (
                            <option key={m.valor} value={m.valor}>{m.etiqueta}</option>
                        ))}
                    </Form.Select>
                </Col>

                <Col xs={12} md={2}>
                    <Form.Label className='fw-semibold small mb-1'>Criterio Fecha</Form.Label>
                    <Form.Select
                        size='sm'
                        value={filtros.criteriosFecha}
                        onChange={(e) => handleRangoChange('criteriosFecha', e.target.value)}
                    >
                        {CRITERIOS_FECHA.map((c) => (
                            <option key={c} value={c}>{c || '— Sin criterio —'}</option>
                        ))}
                    </Form.Select>
                </Col>

                <Col xs={6} md={1}>
                    <Form.Label className='fw-semibold small mb-1'>Desde</Form.Label>
                    <Form.Control
                        size='sm'
                        type='date'
                        value={filtros.fechadesde}
                        onChange={(e) => handleRangoChange('fechadesde', e.target.value)}
                    />
                </Col>

                <Col xs={6} md={1}>
                    <Form.Label className='fw-semibold small mb-1'>Hasta</Form.Label>
                    <Form.Control
                        size='sm'
                        type='date'
                        value={filtros.fechahasta}
                        onChange={(e) => handleRangoChange('fechahasta', e.target.value)}
                    />
                </Col>

                <Col xs={12} md={2} className='d-flex align-items-end gap-2'>
                    <Button variant='primary' size='sm' className='w-100' onClick={onBuscar}>
                        Buscar
                    </Button>
                    <Button
                        variant='outline-secondary'
                        size='sm'
                        onClick={() => dispatch(setFiltrosDirecto(FILTROS_VACIOS))}
                    >
                        Limpiar
                    </Button>
                </Col>

            </Row>
        </div>
    )
}

export default FiltroPanelDirecto
